module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Uploader is a button that indicates the ability of the use to upload assets through the interface.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Uploader uploadState=&quot;default&quot;/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Uploader/README.md
// module id = 410
// module chunks = 0